export const FLOW_NODE_WIDTH = 150;
export const FLOW_NODE_HEIGHT = 60;
export const STICKY_NODE_WIDTH = 32;
export const STICKY_NODE_HEIGHT = 32;
